import api from '@/api'

export default {
  all: (filter) => api('get', '/proposal', filter),
  create: (data) => api('post', '/proposal', data),
  show: (id) => api('get', `/proposal/${id}`),
  delete: (id) => api('delete', `/proposal/${id}`),
  update: (data) => api('put', `/proposal/${data.id}`, data),
  download: (id) => api('get', `/proposal/${id}/download`, id),
  updateStatus: (data) => api('put', `/proposal/${data.proposal_id}/status/${data.status_id}`, data),
  userApprove: (data) => api('put', `/proposal/${data.id}/approve`, data),
  pending: () => api('get', '/approvals/pending'),
  upload: (data) => api('post', `/proposal/${data.get('id')}/upload`, data)
}
